import { useTranslation } from 'react-i18next';

import { Chip } from 'shared/components/chips/Chip';

import type { ChipProps } from '@mui/material';
import type { FC } from 'react';

export const BETA_CHIP_TEST_ID = 'beta-chip';

export const BetaChip: FC<ChipProps> = props => {
  const { t } = useTranslation();

  return (
    <Chip
      data-testid={BETA_CHIP_TEST_ID}
      label={t(`components.chips.beta.title`)}
      size="small"
      color="teal"
      {...props}
    />
  );
};
